<ngx-spinner
  bdColor="rgba(51, 51, 51, 0.8)"
  color="#fff"
  type="ball-spin-clockwise-fade"
  [name]="spinnerName()"
  [size]="spinnerSize()"
  [fullScreen]="isFullScreen()">
  <p id="overlay-spinner-text" [ngClass]="textSizeClass()">{{ text() }}</p>
</ngx-spinner>
